export default {"src":"/_next/static/media/detached-icon.dab02ce8.svg","height":86,"width":116,"blurWidth":0,"blurHeight":0};